var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSubstack = function SvgSubstack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.846 5.061c0-.315.241-.571.539-.571h9.23c.298 0 .539.256.539.571v1.96c0 .315-.241.57-.539.57h-9.23c-.298 0-.539-.255-.539-.57V5.06Zm1.077.572v.816h8.154v-.816H3.923ZM2.846 8.98c0-.316.241-.572.539-.572h9.23c.298 0 .539.256.539.572v5.877c0 .201-.1.387-.262.49a.512.512 0 0 1-.53.014L8 12.88l-4.361 2.48a.512.512 0 0 1-.53-.014.58.58 0 0 1-.263-.49V8.98Zm1.077.571v4.351l3.822-2.173c.16-.09.35-.09.509 0l3.823 2.174V9.55H3.923ZM2.846 1.143c0-.316.241-.572.539-.572h9.23c.298 0 .539.256.539.572v1.959c0 .316-.241.571-.539.571h-9.23c-.298 0-.539-.255-.539-.571v-1.96Zm1.077.571v.817h8.154v-.817H3.923Z",
    fill: "currentColor"
  })));
};
export default SvgSubstack;